import Api from "./Repository.js"

export default function DefaultCRUD(resource) {

    const get = (id=false, params) => {
        if (!id) {
          return Api.get(`${resource}/`, { params: params })
        }
        return Api.get(`${resource}/${id}/`)
    }

    const create = (data, params) => {
        return Api.post( `${resource}/`, data, { params: params })
    }

    const update = (id, data, params) => {
        return Api.patch( `${resource}/${id}/`, data, { params: params })
    }

    const remove = (id) => {
        return Api.delete(`${resource}/${id}/`)
    }

    return {
        get,
        create,
        update,
        remove
    }
}
